//https://mapbox.github.io/togeojson/

import { TObject } from "../../common/TObject";
import {CRMMapClass} from "../CRMMapClass";

import { GoogleMapsBar, GoogleMapsButton, calculateGeometry, guid, instanceOverlay } from "../../common/GoogleObjects";
import { ColorSelect } from "./ColorSelect";

import { Features, FeatureType } from "./Features/Features";
import { Feature } from "./Features/Feature";
import { LabelFeature } from "./Features/LabelFeature";
import { GoogleFeature } from "./Features/GoogleFeature";

import { ToolBarState } from "./Toolbar";


export enum State {
    Unknown,
    View,
    Edit
}

export enum DrawMode {
    None,
    Google,
    Label
}


export class Drawing extends TObject {
    crmmap: CRMMapClass;
    map: any; //google map
    drawingManager: any;
    Features: Features = new Features(this);
    state: State = State.Unknown;
    mode: DrawMode = DrawMode.None;
    clean: boolean = true;

    supportedColors: string[] = ['#00FF00', '#FF1493', '#32CD32', '#FF8C00', '#4B0082', '#FFFF00', '#FF0000', '#000000'];

    actionButtons: any[] = [];
    limitOverlays = null;

    colorPicker: ColorSelect = null;
    selectedFeature: Feature = null;
    history: string[] = [];
    undo: boolean = false;
    readonly: boolean = false;

    polyOptions = {
        strokeWeight: 2,
        strokeOpacity: 1,
        fillOpacity: 1,
        draggable: true,
        editable: true,
        zIndex: 1
    };

    polyLine = {
        strokeWeight: 2,
        strokeOpacity: 1,
        draggable: true,
        editable: true,
        zIndex: 1,
        fillOpacity: 0,

    };


    constructor(owner, crmmap, map, readonly = false) {
        super(owner);
        this.crmmap = crmmap;
        this.map = map;
        this.Features.map = map;
        this.readonly = readonly;
        this.Features.readonly = readonly;

        if (readonly) {
            this.load();
            return this;
        }

        var opt = <google.maps.drawing.DrawingManagerOptions>{
            drawingControl: false,
            rectangleOptions: this.polyOptions,
            circleOptions: this.polyOptions,
            polygonOptions: this.polyOptions,
            polylineOptions: this.polyLine,
            drawingMode: null,

            drawingControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
                drawingModes: [
                    google.maps.drawing.OverlayType.CIRCLE,
                    google.maps.drawing.OverlayType.RECTANGLE,
                    google.maps.drawing.OverlayType.POLYGON,
                    google.maps.drawing.OverlayType.POLYLINE,
                ]
            }

        };
        this.drawingManager = new google.maps.drawing.DrawingManager(opt);


        google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (e) => {
            this.setSelection(null);
            this.debug('overlaycomplete', e);
            e.overlay.type = e.type;
            e.overlay.feature = this.instanceFeature(e.overlay);
            var Feature = this.Features.addGoogleFeature(e.overlay, this);
            this.setSelection(Feature);
            Feature.updateGeometry();
        });

        /*    google.maps.event.addListener(this.drawingManager, 'drawingmode_changed', () => {
               this.selectMode(this.drawingManager.get('drawingMode'));
               this.clearSelection();
           }); */

        google.maps.event.addListener(this.map, 'click', (e) => {

            if (!(e == null))
                this.doClick(e);
        });


        this.createActionButtons();
        this.selectColor(this.supportedColors[0]);
        this.viewMode();


        this.load();


        this.when('changed', () => {
            this.setClean(false);
            this.saveHistory()
        });


        this.when('refresh', () => {
            if (this.undo) {
                this.actionButtons['undo'].style.opacity = this.history.length <= 0 ? '0.5' : '1';
            }

            this.actionButtons['save'].classList.toggle('active', !this.clean);
        });

        this.trigger('refresh');


    }



    saveHistory() {

        this.map.data.toGeoJson((collection) => {
            var s = JSON.stringify(collection);
            if (this.history.length > 0) {
                if (this.history[this.history.length - 1] == s) {
                    //   this.debug('History>', 'do nothing');
                    this.trigger('refesh');
                    return false;
                }
            }


            this.history.push(JSON.stringify(collection));

            while (this.history.length > 10) {
                this.history.shift();
            }


            this.trigger('refesh');

        });
    }

    backup() {
        var j: string = '';
        if (j = this.history.pop()) {
            this.event('changed').enabled = false;
            this.deleteAll();

            var features = JSON.parse(j);
            this.loadFeaturesCollection(features.features);
            this.event('changed').enabled = true
        }


        this.trigger('refesh');

    }

    setClean(to: boolean) {
        this.clean = to;
        this.trigger('refresh');
    }
    //--sTates

    setState(state: State) {
        if ( this.readonly ) {
            //don't allow it to change
            state = State.View;
        }


        if (state == this.state) {
            return this;
        }

        switch (state) {
            case State.View:
                this.drawingManager.setOptions({
                    drawingControl: false
                });
                this.drawingManager.setMap(null);

                this.clearSelection();
                break;

            case State.Edit:
                this.drawingManager.setOptions({
                    drawingControl: false
                });
                this.drawingManager.setMap(this.map);
                break;

        }

        this.state = state;
        this.Features.editable(false);
    }

    editMode() {
        this.setState(State.Edit);
    }

    viewMode() {
        this.setState(State.View);
    }



    private doClick(_e) {
        if ( this.readonly ) {
            return this; //no nthing
        }

        if (this.mode == DrawMode.Label) {
            var f = new LabelFeature(this,this.readonly);
            f.id = guid();
            this.Features.add(f);
            f.setPosition(_e.latLng);
            f.setColor(this.colorPicker.get());
            this.setSelection(f);

        } //else
        //      this.clearSelection();


    }

    public setSelection(Feature: Feature) {

        if ( this.readonly ) {
            return false; //no nthing
        }
        if (this.state == State.View) {
            return false;
        }
        if (this.selectedFeature == Feature) {
            return false;
        }
        this.clearSelection();

        this.selectedFeature = Feature;
        this.selectedFeature.editable(true);

        this.selectColor(Feature.getcolor());

        this.selectMode(null);


    }

    public clearSelection() {
        if (this.selectedFeature) {
            this.selectedFeature.editable(false);
            this.selectedFeature = null;
        }
    }

    private deleteSelectedFeature() {
        if ( this.readonly ) {
            return this; //do nthing
        }
        if (this.selectedFeature) {
            this.deleteFeature(this.selectedFeature);
            this.selectedFeature = null;
            this.changed();
        }
    }

    private deleteFeature(feature: Feature) {
        if ( this.readonly ) {
            return this; //do nthing
        }
        this.Features.deleteFeature(feature);
    }

    private deleteAll() {
        if ( this.readonly ) {
            return this; //do nthing
        }
        this.clearSelection();
        while (this.Features.Features.length > 0) {
            this.deleteFeature(this.Features.Features[0]);
        }


    }




    getGeoJson() {
        return new Promise((resolve) => {
            return this.map.data.toGeoJson((collection) => {
                this.debug('collectioncollectioncollection', collection);
                for (const key in collection.features) {
                    var f = this.Features.findFeatureById(collection.features[key].id);
                    collection.features[key].locationId = f.getLocationId();
                }
                this.debug('collectioncollectioncollection', collection);
                return resolve(collection);
            });
        });

    }

    save() {
        if ( this.readonly ) {
            return this; //do nthing
        }

        Promise.all([
            this.getGeoJson(), this.Features.getFeatures(FeatureType.LABEL)]).then((res) => {
                var collection = <any>res[0];
                collection.others = <Feature[]>res[1];
                var s = JSON.stringify(collection);
                this.crmmap.Data.Features.save('', { 'name': 'Layer1', 'geojson': s })
                    .then(() => { this.setClean(true); });
            });
    }

    private loadFeature(feature) {

        return new Promise((resolve, reject) => {
            try {
                if (!feature.geometry) {
                    return reject('No feature Geometry');
                }

                var p = null;
                if (feature.type == FeatureType.LABEL) {
                    p = new LabelFeature(this, this.readonly);
                    p.id = feature.id;
                    var a = feature.geometry.coordinates;
                    p.setPosition(new google.maps.LatLng(a[1], a[0]))
                    p.setProperties(feature.properties);
                    this.Features.add(p);
                } else {
                    p = instanceOverlay(feature, this.polyOptions);
                    p.feature = this.instanceFeature(p);
                    p = this.Features.addGoogleFeature(p, this)
                        .setColor(feature.properties.color)
                        .updateGeometry();
                }

                if (feature.locationId) {
                    p.setLocationId(feature.locationId);
                }
                return resolve(p);
            }
            catch (err) {
                this.debug(err);
                console.error('features Error:', err.message);
                console.error(feature);
                return reject(err.message);
            }
        }).then(() => { this.saveHistory() });
    }


    private loadFeaturesCollection(features) {

        if (!(Array.isArray(features) && features.length > 0)) {
            this.debug('No Features to load');
            return false;
        }
        return new Promise((resolve, reject) => {
            if (!(Array.isArray(features) && features.length > 0)) {
                return reject('No features');
            }
            var promises_array: Array<any> = [];
            features.forEach(feature => {
                promises_array.push(this.loadFeature(feature));
            });
            return Promise.all(promises_array).then((d) => {
                return resolve(d);
            });
        });

    }

    d() {

        /*     var debugdiv = document.getElementById("debugdiv");
    
            Promise.all([
                this.getGeoJson(), this.Features.getFeatures(FeatureType.LABEL)]).then((res) => {
                    var collection = <any>res[0];
                    collection.others = <Feature[]>res[1];
                    var s = JSON.stringify(collection);
    
                    debugdiv.innerHTML = '';
                    collection.features.forEach(element => {
                        debugdiv.innerHTML += element.properties.color + ' <br/>';
                    });
                }); */
    }

    reload() {
        this.crmmap.Data.Features.invaledate();
        this.deleteAll();
        this.load();
    }

    load() {
        this.event('changed').enabled = false;
        this.crmmap.Data.Features.get().then((data) => {

            var promises_array: Array<any> = [];
            data.forEach(element => {
                var features = JSON.parse(element.Geojson);
                if (features.features)  promises_array.push(this.loadFeaturesCollection(features.features));
                if (features.others)    promises_array.push(this.loadFeaturesCollection(features.others));
            });
            Promise.all(promises_array).then(() => {
                this.event('changed').enabled = true;
                this.setClean(true);
                this.d();
            });
        }).catch((error) => {
            console.error('Error Loading Features');
            console.error(error);
        });
    }

    selectColor(color) {

        if ( this.readonly ) {
            return this; //do nthing
        }

        if (this.selectedFeature != null) this.selectedFeature.setColor(color);
        if (this.drawingManager) {
    // Retrieves the current options from the drawing manager and replaces the
            // stroke or fill color as appropriate.
            var polylineOptions = this.drawingManager.get('polylineOptions');
            polylineOptions.strokeColor = color;
            this.drawingManager.set('polylineOptions', polylineOptions);

            var rectangleOptions = this.drawingManager.get('rectangleOptions');
            rectangleOptions.fillColor = color;
            this.drawingManager.set('rectangleOptions', rectangleOptions);

            var circleOptions = this.drawingManager.get('circleOptions');
            circleOptions.fillColor = color;
            this.drawingManager.set('circleOptions', circleOptions);

            var polygonOptions = this.drawingManager.get('polygonOptions');
            polygonOptions.fillColor = color;
            this.drawingManager.set('polygonOptions', polygonOptions);
        }
        if ( this.colorPicker) {
            this.colorPicker.set(color);
        }

       
    }



    setSelectedFeatureColor(color) {
        if ( this.readonly ) {
            return this; //do nthing
        }
        if (this.selectedFeature) {
            this.selectedFeature.setColor(color);
        }
    }



    //creates a Feature from an Overlay
    instanceFeature(overlay) {
        var calculatedOverlay = <any>calculateGeometry(overlay, false);
        if (!calculatedOverlay) {
            console.error('instanceFeature:  calculatedOverlay blank');
            return false;
        }
        if (overlay.type) {

            var _color = "#0000FF";


            switch (overlay.type) {
                case google.maps.drawing.OverlayType.MARKER:
                    console.error("No Color on Marker");
                    break;
                case google.maps.drawing.OverlayType.RECTANGLE:
                case google.maps.drawing.OverlayType.POLYGON:
                case google.maps.drawing.OverlayType.CIRCLE:
                    _color = overlay.fillColor;

                    break;
                case google.maps.drawing.OverlayType.POLYLINE:
                    _color = overlay.strokeColor;
                    break;

                default:
                    console.error("Unhandled Type ", overlay.type);
                    break;
            }



        } else {
            console.error('no Overlay Type', overlay);
        }



        return this.map.data.add(new google.maps.Data.Feature({
            id: guid(),
            geometry: calculatedOverlay.geometry,
            properties: Object.assign({
                type: overlay.type,
                color: _color
            },
                calculatedOverlay.hasOwnProperty('properties') ? calculatedOverlay.properties : {}
            )
        }));
    }





     selectMode(mode: any) 
    {
        if ( this.readonly ) {
            return this; //do nthing
        }
        switch (mode) {
            case DrawMode.Label:
                this.mode = mode;
                this.map.setOptions({ gestureHandling: 'greedy', draggableCursor: 'crosshair' });
                this.drawingManager.setDrawingMode(null);
                break;
            default:
                this.mode = (mode == null) ? DrawMode.None : DrawMode.Google;
                this.map.setOptions({ gestureHandling: 'greedy', draggableCursor: '' });

                if (mode != this.drawingManager.get('drawingMode')) {
                    this.drawingManager.setDrawingMode(mode);
                }
                break;
        }


        //this is a hack, but it's staying for now
        if (mode == DrawMode.Label) {
            mode = 'label';
        }
        for (var ab in this.actionButtons) {
            if (!mode) {
                this.actionButtons[ab].classList.toggle('active', false);
            } else {
                this.actionButtons[ab].classList.toggle('active', ab == mode);
            }
        }

        if (!mode) {
            this.actionButtons['select'].classList.toggle('active', true);
        }
        
        if (mode != 'NOTHING') {
            if (this.crmmap.Map) {
                if (this.crmmap.Map.Toolbar.state != ToolBarState.DRAW) {
                    this.crmmap.Map.Toolbar.setState(ToolBarState.DRAW, false);
                }
            }
        }


    }

    private createActionButtons() {
        //Create action buttons
        var changemode = (event, option) => {
            this.selectMode(option.mode);
            this.clearSelection();
        };

        var actions = [];

        actions.push({ name: 'select', mode: null, func: changemode });
        actions.push({ name: 'rectangle', mode: google.maps.drawing.OverlayType.RECTANGLE, func: changemode });
        actions.push({ name: 'polygon', mode: google.maps.drawing.OverlayType.POLYGON, func: changemode });
        actions.push({ name: 'polyline', mode: google.maps.drawing.OverlayType.POLYLINE, func: changemode });
        actions.push({ name: 'label', mode: DrawMode.Label, func: changemode });
        actions.push({ name: 'delete', mode: null, func: () => { this.deleteSelectedFeature() } });
        actions.push({ name: 'save', mode: null, func: () => { this.save(); } });
        if (this.undo)
            actions.push({ name: 'undo', mode: null, func: () => { this.backup(); } });

        actions.forEach(element => {
            this.actionButtons[element.name] = document.getElementById('draw' + element.name);
            if (this.actionButtons[element.name]) {
                google.maps.event.addDomListener(this.actionButtons[element.name], 'click', (event) => {
                    console.log('click', element.name);
                    element.func(event, element);
                });
            }

        });

        var drawcolor = document.getElementById('drawcolor');
        var drawcolorsel = document.getElementById('drawcolorsel');

        this.colorPicker = new ColorSelect(this, { frame: drawcolorsel });





        this.colorPicker.when('changed', () => {
            var color = this.colorPicker.get();
            this.selectColor(color);
            this.setSelectedFeatureColor(color);
        });


    }
}
